module.exports = __webpack_public_path__ + "fonts/THICCCBOI-SemiBold.49ef00a3.woff2";